import type { OperationError, VideoOperationResult } from '../../../domain';

/**
 * Thrown by `useVideoOperationMutation` when a job resolves to
 * `status: 'Failed'` or `'Cancelled'`. The HTTP envelope says `success: true`
 * — the terminal `status` is the real signal. Carrying a typed class lets the
 * canvas distinguish a provider/render failure from a network throw and read
 * the structured `OperationError` (code, message, retryable) for a Retry CTA.
 */
export class VideoOperationFailedError extends Error {
  readonly result: VideoOperationResult;
  readonly operationError: OperationError | null;
  readonly code: string;
  readonly retryable: boolean;

  constructor(result: VideoOperationResult) {
    const message =
      result.error?.message?.trim() ||
      `Render ${result.status.toLowerCase()} without a message.`;
    super(message);
    this.name = 'VideoOperationFailedError';
    this.result = result;
    this.operationError = result.error ?? null;
    this.code = result.error?.code ?? 'VIDEO_OPERATION_FAILED';
    this.retryable = result.error?.retryable ?? false;
  }
}
